import { useEffect, useState } from "react";
import { getNegotiationsAwaiting } from "../api/negotiationAwaiting";

const REFRESH_MS = 5 * 60 * 1000;

// What is waiting on the signed-in party in negotiations, for the sidebar badge. Refreshes on navigation
// and every few minutes; errors are ignored.
export default function useNegotiationAlerts(token, pathname) {
  const [state, setState] = useState({ count: 0, items: [] });

  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;

    const load = () =>
      getNegotiationsAwaiting(token)
        .then(({ data }) => {
          if (cancelled) return;
          const items = data.data || [];
          setState({ count: typeof data.count === "number" ? data.count : items.length, items });
        })
        .catch(() => {});

    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [token, pathname]);

  return state;
}
